import { useEffect } from 'react';

export const useAnonNavigationGuard = (isAuthenticated: boolean) => {
  useEffect(() => {
    if (isAuthenticated) return;

    const handleDocumentClick = (event: MouseEvent) => {
      if (event.defaultPrevented) return;
      if (event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const target = event.target;
      if (!(target instanceof Element)) return;

      const anchor = target.closest('a[href]');
      if (!(anchor instanceof HTMLAnchorElement)) return;
      if (anchor.target === '_blank' || anchor.hasAttribute('download')) return;

      const href = anchor.getAttribute('href');
      if (!href) return;

      let destination: URL;
      try {
        destination = new URL(href, window.location.href);
      } catch {
        return;
      }
      if (destination.protocol !== 'http:' && destination.protocol !== 'https:') return;
      if (destination.origin === window.location.origin) return;

      const confirmed = window.confirm(
        'You are not signed in. Leaving this page will lose your current session. Continue?',
      );
      if (!confirmed) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    document.addEventListener('click', handleDocumentClick, true);
    return () => document.removeEventListener('click', handleDocumentClick, true);
  }, [isAuthenticated]);
};
